import { paginatedTransform } from 'src/services/skuit/utils'
import { Client, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export class Clients {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Client>> => {
    const response = await this.api.get('/accounts/clients', config)
    return paginatedTransform(Client)(response.data)
  }
}
